import { useEffect, useRef, useState, useCallback } from "react";
import { getLoyaltySDK } from "../api/loyaltySdk";
import getValueFromCookie from "../utils/getValueFromCookie";

export default function useLoyalty(benefitType) {
  const [hasBenefit, setHasBenefit] = useState(null);
  const [tierId, setTierId] = useState(null);
  const sdkRef = useRef(null);

  const fetchBenefit = useCallback(async () => {
    try {
      if (!sdkRef.current) {
        sdkRef.current = await getLoyaltySDK();
      }

      if (tierId) {
        const benefit = await sdkRef.current.isBenefitAvailableForTier(
          tierId,
          benefitType,
        );
        setHasBenefit(benefit);
      }
    } catch {
      setHasBenefit(false);
    }
  }, [benefitType, tierId]);

  useEffect(() => {
    if (!tierId) {
      const fetchedTierId = getValueFromCookie("customerLoyaltyTier");
      if (fetchedTierId) {
        setTierId(fetchedTierId);
      }
    } else {
      fetchBenefit();
    }
  }, [tierId, fetchBenefit]);

  return hasBenefit;
}
